import { envHelper } from "@dinahmoe/dmafjs-assetloader/src/env/utils/envHelper";
import { appendFileExtension, hasExtension } from "@dinahmoe/dmafjs-assetloader/src/env/utils/path";

let sharedAudioCtx;

class WebAudioLoader {
  key = "buffer";

  async load(assetsPath) {
    const allowedExtension = envHelper.getAudioSupportedExtension();
    const filename = assetsPath.split("/").pop();
    const hasExt = filename.includes(".") && hasExtension(assetsPath);
    const url = hasExt
      ? assetsPath
      : appendFileExtension(assetsPath, allowedExtension);

    const response = await fetch(url);
    const buffer = await response.arrayBuffer();

    if (!sharedAudioCtx) {
      sharedAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    const audioCtx = sharedAudioCtx;

    const audioBuffer = await new Promise((resolve, reject) => {
      audioCtx.decodeAudioData(
        buffer,
        (buffer) => {
          resolve(buffer);
        },
        (e) => {
          reject(e);
        }
      );
    });

    //https://stackoverflow.com/questions/52489787/audiocontext-decodeaudiodata-not-working-on-iphone-but-working-everywhere-e

    return {
      content: audioBuffer,
      representation: {
        length: audioBuffer.length,
        duration: audioBuffer.duration * 1000, //dmaf uses time in milliseconds
        sampleRate: audioBuffer.sampleRate,
        numberOfChannels: audioBuffer.numberOfChannels,
      },
    };
  }
}

const webAudioLoader = new WebAudioLoader();
export { webAudioLoader, WebAudioLoader };
